import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './controlePatioChecklistForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';

import { 
	setModoTelaChecklist as setModoTela, setFiltro, initFormChecklist as initForm, inicializarChecklist, getLista,
	getListaMotorista, getListaPlaca, getListaChecklist, salvarChecklist
} from './controlePatioActions';

const columns = [{
    field: 'cavalo',
    type: 'text'
}];

class ControlePatio extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'cavalo',
			direction: 'asc'
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();

		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaChecklist();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
		}, 30000);
    }

	componentWillUnmount() {
		clearInterval(this.idIntervalAtualizacao);
	}

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'checklist' ? (
						<Form onSubmit={(registro) => this.props.salvarChecklist(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisarChecklist || '').trim()
				|| (this.props.filtro.pesquisarChecklist.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.cavalo}
						${item.carreta1 || ''}
						${item.carreta2 || ''}
						${item.nome_motorista}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}
					`.toUpperCase().includes(pesquisar.trim())
					);
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}

	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar();

		const heightTela = `${window.innerHeight - 210}px`;

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisarChecklist}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisarChecklist: value })} />
					</Row>
					
					<Row>
						{this.props.listaStatus.map(status => (
							<Grid key={status.id} cols='12 12 12 12'>
								<div style={{ height: heightTela, backgroundColor: '#1F3066' }}>
									<Table responsive noHover alturaFixa backgroundColor={'#1F3066'} style={{ borderCollapse: 'collapse', border: 'none' }}
										maxHeight={heightTela}>
										<THead>
											<Tr backgroundColor={'#1F3066'}
												color={'#ffffff'}
												height={47}>								
												<ThSort
													field='cavalo'
													label={'Aguardando Checklist'}
													width={300}
													sticky />
											</Tr>
										</THead>
										<TBody>
											{lista.filter(item => item.id_status == status.id && !item.checklist_respondido).map((item, i) => (
												<tr key={item.id} style={{ border: 'none' }}>
													<td style={{ border: 'none', padding: 4 }} align='center'>
														<div className='controle-patio-card-hover'
															onClick={() => {

																this.props.inicializarChecklist({
																	...item
																});

															}}>
															<div style={{
																display: 'flex',
																flexDirection: 'column',
																justifyContent: 'center',
																alignItems: 'center',
																fontSize: 16,
																fontWeight: 'bold',
																width: 100
															}}>
																<div>
																	{item.cavalo}
																</div>
																{(item.carreta1 || item.carreta2) &&
																<div style={{ fontSize: 9, fontWeight: 'bold' }}>
																	{item.carreta1}
																	{item.carreta1 && item.carreta2 ? ' | ' : ''}
																	{item.carreta2}
																</div>}
															</div>
															<div style={{
																display: 'flex',
																flexDirection: 'column',
																justifyContent: 'center',
																alignItems: 'flex-start',
																fontSize: 12
															}}>
																<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
																	<i class='fas fa-user' style={{ marginRight: 4 }}></i>
																	<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.nome_motorista}</div>
																</div>
																<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
																	<i class='fas fa-calendar-check' style={{ marginRight: 4 }}></i>
																	<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>Prev. Saída:</b> {DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}</div>
																</div>
																{/*
																<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
																	<i class='fas fa-stopwatch' style={{ marginRight: 4 }}></i>
																	<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>Saída em:</b> {DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}</div>
																</div>*/}
															</div>
														</div>
													</td>
												</tr>
											))}
										</TBody>
									</Table>
								</div>
								<div
									style={{
										backgroundColor: '#1F3066',
										padding: 2,
										paddingRight: 18,
										width: '100%',
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center'
									}}
								>
									<div
										style={{
											width: 140,
											backgroundColor: '#ffffff',
											textAlign: 'center',
											fontSize: 11,
											fontWeight: 'bold',
											color: '#1F3066',
											padding: '6px 10px',
											borderRadius: 6,
											boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
											/* cria o recuo no canto superior esquerdo */
											clipPath: 'polygon(12px 0, 100% 0, 100% 100%, 0 100%, 0 12px)'
										}}
									>
										{this.getTextLabelRegistros(
											lista.filter(item => item.id_status == status.id && !item.checklist_respondido).length
										)}
									</div>
								</div>

							</Grid>
						))}
					</Row>
				</ContentCardBody>
			</ContentCard>
		);
	}

	getTextLabelRegistros(tamanho) {
		if (tamanho == 0) {
			return 'Nenhum registro';
		} else if (tamanho == 1) {
			return '1 registro';
		} else {
			return `${tamanho} registros`;
		}
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.controlePatio.aguardando,
	modoTela: state.controlePatio.modoTelaChecklist,
	lista: state.controlePatio.lista,
	filtro: state.controlePatio.filtro,
	listaStatus: state.controlePatio.listaStatus.filter(item => item.id == 3), //Aguardando Saída
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, inicializarChecklist, getLista,
	getListaMotorista, getListaPlaca, getListaChecklist, salvarChecklist
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatio);
